import React, { useEffect, useState, Fragment, useRef } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Typography,
  Stack,
  Box,
  Grid,
  IconButton,
  Button,
  TextField,
  DialogActions,
  Divider,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { BsPrinter } from "react-icons/bs";
import { useQuery } from "@apollo/client";
import { ToWords } from "to-words";
import ReactToPrint from "react-to-print";
//date picker
import moment from "moment";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Srcs
import "../../Style/pagestyle.scss";
import { currencyFormat, currencyFormatRiel } from "../../Function/DynamicFn";
import {
  GET_DISBURSEMENT_BY_ID,
  GET_EXCHANGE_RATE,
} from "../../Schema/Disbursement";
import LogoSchool from "../../Assets/GoGlobalMart.png";
import WingdingImage from "../../Assets/tacteing.jpg";

export default function CreateDisbursement({ open, handleClose, editData }) {
  // 
  const getHeadOffice = window.localStorage.getItem("headOffice");
  const getRegistrationSection = window.localStorage.getItem(
    "RegistrationSetcion"
  );

  const toWords = new ToWords({
    localeCode: "en-US",
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: true,
    },
  });

  //==================================Amount in word=========================
  const [showAmountInWord, setShowAmountInWord] = useState(false);
  const [amountInWord, setAmountInWord] = useState(
    JSON.parse(localStorage.getItem("amountInWordFromLocal"))
  );

  const handleShowAmountInWord = (name) => {
    setAmountInWord(name);
    localStorage.setItem("amountInWordFromLocal", JSON?.stringify(name));
  };

  //==================================Received by=========================
  const [showReceivedBy, setShowReceiveBy] = useState(false);
  const [receivedByValue, setReceivedByValue] = useState(
    JSON.parse(localStorage.getItem("receiveByFromLocal"))
  );
  const handleReceiveBy = (name) => {
    setReceivedByValue(name);
    localStorage.setItem("receiveByFromLocal", JSON?.stringify(name));
  };

  //==================================Paid by ========================
  const [showPiadBy, setShowPaidBy] = useState(false);
  const [paidByValue, setPaidByByValue] = useState(
    JSON.parse(localStorage.getItem("paidByFromLocal"))
  );
  const handlePaidBy = (name) => {
    setPaidByByValue(name);
    localStorage.setItem("paidByFromLocal", JSON?.stringify(name));
  };

  // =================================Approved by==================================
  const [showApprovedBy, setShowApprovedBy] = useState(false);
  const [approvedByValue, setApprovedByValue] = useState(
    JSON.parse(localStorage.getItem("approvedByFromLocal"))
  );
  const handleApprovedBy = (name) => {
    setApprovedByValue(name);
    localStorage.setItem("approvedByFromLocal", JSON?.stringify(name));
  };
  // =================================Certifeid by==================================
  const [showCertifiedBy, setShowCertifiedBy] = useState(false);
  const [certifiedByValue, setCertifiedByValue] = useState(
    JSON.parse(localStorage.getItem("certifiedByFromLocal"))
  );
  const handleCertifiedBy = (name) => {
    setCertifiedByValue(name);
    localStorage.setItem("certifiedByFromLocal", JSON?.stringify(name));
  };
  // =================================Prepare by==================================
  const [showPrepareBy, setShowPrepareBy] = useState(false);
  const [prepareByValue, setPrepareByValue] = useState(
    JSON.parse(localStorage.getItem("prepareByFromLocal"))
  );
  const handlePrepareBy = (name) => {
    setPrepareByValue(name);
    localStorage.setItem("prepareByFromLocal", JSON?.stringify(name));
  };

  const [loading, setLoading] = useState(false);
  const [printData, setPrintData] = useState([]);
  // const [exchangeRateData, setExchangeRateData] = useState([]); 
  const { refetch } = useQuery(GET_DISBURSEMENT_BY_ID, {
    variables: {
      id: editData?._id,
    },
    onCompleted: ({ getDisbursementId }) => {
      // console.log("getDisbursementId==>", getDisbursementId);
      setPrintData(getDisbursementId);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [editData?._id]);

  // print

  const componentRef = useRef(null);
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button sx={{ marginTop: "30px" }} className="btn-print-disbusement">
        Print
      </Button>
    );
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Print Disbursement</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />

          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Box className="dibursement-print-container" ref={componentRef}>
          <Box sx={{ marginTop: "10px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="row" justifyContent="left">
                  <Stack direction="column" sx={{ paddingLeft: "20px" }}>
                    <Stack direction="row" justifyContent="center">
                      <img src={LogoSchool} className="logo-size" />
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography className="disbursement-title-kh">
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </Typography>
                  {/* <Typography className="disbursement-title">
                    Kingdom Of Cambodia
                  </Typography> */}
                  <Typography className="disbursement-title-kh">
                    ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                  </Typography>
                  {/* <Typography className="disbursement-title">
                    Nation Religions King
                  </Typography> */}
                  <Stack direction="row" justifyContent="center">
                    <img
                      alt="Image"
                      src={WingdingImage}
                      className="disbursement-tackteng"
                    />
                  </Stack>

                  <Typography
                    className="disbursement-table-title"
                    marginTop="40px"
                  >
                    សក្ខីប័ណ្ណចំណាយសាច់ប្រាក់
                  </Typography>
                  <Typography className="disbursement-table-title-eng">
                    Cash Disbursement Voucher
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="row"
                  justifyContent="right"
                  sx={{ marginTop: "100px" }}
                >
                  <Stack direction="column" sx={{ width: "60%" }}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="thead-text-dusburment">
                        លេខរៀង :
                      </Typography>
                      <Typography className="thead-text-dusburment">
                      {(printData?.numbering)?.slice(4)} / {(printData?.numbering)?.slice(2, 4)}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="thead-text-dusburment">
                        កាលបរិច្ឆេទ :
                      </Typography>
                      <Typography className="thead-text-dusburment">
                        {moment(printData?.date).format("DD-MMM-YY")}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          <div>
            <table className="table-disbursement">
              <thead>
                <tr>
                  <th
                    className="thead-disbursement"
                    style={{ width: "8% !important" }}
                    rowSpan={2}
                  >
                    កាលបរិច្ឆេទ
                  </th>
                  <th
                    className="thead-disbursement"
                    style={{ width: "22% !important" }}
                    rowSpan={2}
                  >
                    បរិយាយ
                  </th>
                  <th
                    className="thead-disbursement"
                    style={{ width: "16% !important" }}
                    rowSpan={2}
                  >
                    អ្នកផ្គត់ផ្គង់
                  </th>
                  <th
                    className="thead-disbursement"
                    style={{ width: "12% !important" }}
                    rowSpan={2}
                  >
                    វិក្កយបត្រ
                  </th>
                  <th
                    className="thead-disbursement"
                    style={{ width: "6% !important" }}
                    rowSpan={2}
                  >
                    ចំនួន
                  </th>
                  <th
                    className="thead-disbursement"
                    style={{ width: "8% !important" }}
                    rowSpan={2}
                  >
                    តម្លៃរាយ
                  </th>
                  <th
                    className="thead-disbursement"
                    colSpan={2}
                    style={{ width: "28% !important" }}
                  >
                    ទឹកប្រាក់
                  </th>
                </tr>

                <tr>
                  {/* <th className="thead-disbursement">Date</th> */}
                  {/* <th className="thead-disbursement">Description</th> */}
                  {/* <th className="thead-disbursement">Supplier</th> */}
                  {/* <th className="thead-disbursement">INV No.</th> */}
                  {/* <th className="thead-disbursement">Qty</th> */}
                  {/* <th className="thead-disbursement">Exchange</th> */}
                  <th
                    className="thead-disbursement-khr"
                    style={{ width: "14%" }}
                  >
                    រៀល
                  </th>
                  <th
                    className="thead-disbursement-usd"
                    style={{ width: "14%" }}
                  >
                    ដុល្លារ
                  </th>
                </tr>
              </thead>

              <tbody>
                {printData?.disbursements?.map((accountType, index) => {
                  // console.log("accountType::", accountType)
                  return (
                    <Fragment key={index}>
                      <tr>
                        <td className="tbody-disbursement-top"></td>
                        <td
                          className="tbody-disbursement-top"
                          style={{
                            lineHeight: "1.5em",
                            width: "22%",
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {accountType?.code_account} -{" "}
                          {accountType?.accountType}
                        </td>
                        <td className="tbody-disbursement-top"></td>
                        <td className="tbody-disbursement-top"></td>
                        <td className="tbody-disbursement-top"></td>
                        <td className="tbody-disbursement-top"></td>
                        <td className="tbody-disbursement-top"></td>
                        <td className="tbody-disbursement-top"></td>
                      </tr>

                      {accountType?.items?.map((expense, subIndex) => {
                        // console.log("expense::", expense);
                        return (
                          <tr key={subIndex}>
                            <td
                              className="tbody-disbursement"
                              style={{
                                textAlign: "center",
                              }}
                            >
                              {moment(expense?.invDate).format("DD-MMM-YYYY")}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{
                                lineHeight: "1.5em",
                                width: "22%",
                                whiteSpace: "normal",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {subIndex + 1}. {expense?.description}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{
                                lineHeight: "1.5em",
                                width: "16%",
                                whiteSpace: "normal",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {expense?.supplierName}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{
                                textAlign: "center",
                                lineHeight: "1.5em",
                                width: "12%",
                                whiteSpace: "normal",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {expense?.invNo}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{ textAlign: "center" }}
                            >
                              {/* {expense?.qty} */}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{ textAlign: "center" }}
                            >
                              {/* {expense?.exchangeRate
                                ? `${expense?.exchangeRate} ៛`
                                : ""} */}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{ textAlign: "right" }}
                            >
                              {currencyFormatRiel(expense?.priceKHR)}
                            </td>
                            <td
                              className="tbody-disbursement"
                              style={{ textAlign: "right" }}
                            >
                              {currencyFormat(expense?.priceUSD)}
                            </td>
                          </tr>
                        );
                      })}
                    </Fragment>
                  );
                })}
                <tr>
                  <td
                    className="tfood-disbursement"
                    colSpan={6}
                    style={{ textAlign: "center" }}
                  >
                    សរុបទឹកប្រាក់(Total)
                  </td>
                  <td
                    className="tfood-disbursement"
                    style={{ textAlign: "right" }}
                  >
                    ៛ {currencyFormatRiel(printData?.totalKHR)}
                  </td>
                  <td
                    className="tfood-disbursement"
                    style={{ textAlign: "right" }}
                  >
                    $ {currencyFormat(printData?.totalUSD)}
                  </td>
                </tr>
              </tbody>
            </table>

            <Box sx={{ marginTop: "10px" }}>
              <Stack direction="row" spacing={0.8}>
                <Stack direction="column" spacing={0.6}>
                  <Typography
                    className="thead-text-dusburment"
                    sx={{ width: "120px" }}
                  >
                    ចំនួនទីកប្រាក់ជាអក្សរ
                  </Typography>
                  <Typography
                    className="thead-text-dusburment"
                    sx={{ width: "120px" }}
                  >
                    Amount in word
                  </Typography>
                </Stack>
                <Stack direction="column" spacing={0.6}>
                  <Stack direction="column" className="thead-text-dusburment">
                    <Typography
                      className="thead-text-dusburment"
                      onClick={() => setShowAmountInWord(true)}
                      sx={{ cursor: "pointer" }}
                    >
                      {amountInWord
                        ? `: ${amountInWord}`
                        : ": ចំនួនទីកប្រាក់ជាអក្សរ"}
                    </Typography>

                    {showAmountInWord ? (
                      <Typography className="thead-text-dusburment">
                        <TextField
                          className="thead-text-dusburment"
                          size="small"
                          sx={{ width: "100%" }}
                          onMouseLeave={() => setShowAmountInWord(false)}
                          value={amountInWord}
                          onChange={(e) =>
                            handleShowAmountInWord(e?.target?.value)
                          }
                        />
                      </Typography>
                    ) : null}
                  </Stack>
                  {printData?.totalKHR || printData?.totalUSD ? (
                    <Typography className="thead-text-dusburment">
                      : {toWords.convert(printData?.totalKHR)} Riels only and{" "}
                      {toWords.convert(
                        parseFloat(printData?.totalUSD?.toFixed(2))
                      )}{" "}
                      USD only
                    </Typography>
                  ) : null}
                </Stack>
              </Stack>
            </Box>

            <Box marginTop={"30px"}>
              <Grid item container spacing={4}>

                <Grid item xs={3}>
                  <Stack direction="column" spacing={1}>
                    <Stack direction="column" alignItems={"center"}>
                      <Typography className="thead-text-dusburment">
                        អ្នកទទួលប្រាក់
                      </Typography>
                      <Typography className="thead-text-dusburment">
                        Received by
                      </Typography>
                    </Stack>
                    <Stack direction="column" className="thead-text-dusburment">
                      <Typography
                        className="text-field-disbursement"
                        onClick={() => setShowReceiveBy(true)}
                        sx={{
                          marginTop: "50px",
                          borderBottom: "1px solid #c1cbf5",
                          cursor: "pointer",
                        }}
                      >
                        {receivedByValue}
                      </Typography>

                      {showReceivedBy ? (
                        <Typography className="thead-text-dusburment">
                          <TextField
                            className="thead-text-dusburment"
                            size="small"
                            onMouseLeave={() => setShowReceiveBy(false)}
                            value={receivedByValue}
                            onChange={(e) => handleReceiveBy(e?.target?.value)}
                          />
                        </Typography>
                      ) : null}
                    </Stack>
                    <Stack direction="column" width="100%">
                      <Stack direction="row" spacing={0} width="100%">
                        <Typography className="thead-text-dusburment" sx={{ whiteSpace: 'nowrap' }}>
                          Date:
                        </Typography>
                        <Box
                          sx={{
                            borderBottom: '1px dashed gray',
                            flexGrow: 1, 
                            mb: "4px",
                          }}
                        /> 
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>

                <Grid item xs={3}>
                  <Stack direction="column" spacing={1}>
                    <Stack direction="column" alignItems={"center"}>
                      <Typography className="thead-text-dusburment">
                        អ្នកចំណាយ
                      </Typography>
                      <Typography className="thead-text-dusburment">
                        Paid by
                      </Typography>
                    </Stack>
                    <Stack alignItems={"center"} direction="column">
                      <Typography
                        className="text-field-disbursement"
                        onClick={() => setShowPaidBy(true)}
                        sx={{
                          marginTop: "50px",
                          borderBottom: "1px solid #c1cbf5",
                          cursor: "pointer",
                        }}
                      >
                        {paidByValue}
                      </Typography>

                      {showPiadBy ? (
                        <Typography className="thead-text-dusburment">
                          <TextField
                            className="text-field-disbursement"
                            size="small"
                            onMouseLeave={() => setShowPaidBy(false)}
                            value={paidByValue}
                            onChange={(e) => handlePaidBy(e?.target?.value)}
                          />
                        </Typography>
                      ) : null}
                    </Stack>
                    {/* <Stack direction="column">
                      <Typography className="thead-text-dusburment">
                        Date:...........................
                      </Typography>
                    </Stack> */}
                    <Stack direction="column" width="100%">
                      <Stack direction="row" spacing={0} width="100%">
                        <Typography className="thead-text-dusburment" sx={{ whiteSpace: 'nowrap' }}>
                          Date:
                        </Typography>
                        <Box
                          sx={{
                            borderBottom: '1px dashed gray',
                            flexGrow: 1, 
                            mb: "4px",
                          }}
                        /> 
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>

                <Grid item xs={3}>
                  <Stack direction="column" spacing={1}>
                    <Stack direction="column" alignItems={"center"}>
                      <Typography className="thead-text-dusburment">
                        អ្នកអនុម័ត
                      </Typography>
                      <Typography className="thead-text-dusburment">
                        Approved by
                      </Typography>
                    </Stack>
                    <Stack
                      className="text-field-disbursement"
                      alignItems={"center"}
                      direction="column"
                      onClick={() => setShowApprovedBy(true)}
                    >
                      <Typography
                        className="text-field-disbursement"
                        sx={{
                          marginTop: "45px",
                          borderBottom: "1px solid #c1cbf5",
                          cursor: "pointer",
                        }}
                      >
                        {approvedByValue ? approvedByValue : "ឈ្មោះអ្នកអនុម័ត"}
                      </Typography>

                      {showApprovedBy ? (
                        <Typography className="title-student-parents-info">
                          <TextField
                            size="small"
                            onMouseLeave={() => setShowApprovedBy(false)}
                            value={approvedByValue}
                            onChange={(e) => handleApprovedBy(e?.target?.value)}
                          />
                        </Typography>
                      ) : null}
                    </Stack>
                    <Stack direction="column" width="100%">
                      <Stack direction="row" spacing={0} width="100%">
                        <Typography className="thead-text-dusburment" sx={{ whiteSpace: 'nowrap' }}>
                          Date:
                        </Typography>
                        <Box
                          sx={{
                            borderBottom: '1px dashed gray',
                            flexGrow: 1, 
                            mb: "4px",
                          }}
                        /> 
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>


                {/* <Grid item xs={2.4}>
                  <Stack
                    spacing={1}
                    direction="column"
                    sx={{ paddingTop: "5px" }}
                  >
                    <Stack direction="column" alignItems={"center"}>
                      <Typography className="thead-text-dusburment">
                        អ្នកត្រួតពិនិត្យ
                      </Typography>
                      <Typography className="thead-text-dusburment">
                        Certified by
                      </Typography>
                    </Stack>
                    <Stack
                      alignItems={"center"}
                      direction="column"
                      className="text-field-disbursement"
                    >
                      <Typography
                        className="text-field-disbursement"
                        onClick={() => setShowCertifiedBy(true)}
                        sx={{
                          marginTop: "45px",
                          borderBottom: "1px solid #c1cbf5",
                          cursor: "pointer",
                        }}
                      >
                        {certifiedByValue
                          ? certifiedByValue
                          : "ឈ្មោះអ្នកត្រួតពិនិត្យ"}
                      </Typography>

                      {showCertifiedBy ? (
                        <Typography className="title-student-parents-info">
                          <TextField
                            className="text-field-disbursement"
                            size="small"
                            onMouseLeave={() => setShowCertifiedBy(false)}
                            value={certifiedByValue}
                            onChange={(e) =>
                              handleCertifiedBy(e?.target?.value)
                            }
                          />
                        </Typography>
                      ) : null}
                    </Stack>
                    <Stack direction="column">
                      <Typography className="thead-text-dusburment">
                        Date:...........................
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid> */}


                <Grid item xs={3}>
                  <Stack
                    direction="column"
                    spacing={1}
                    sx={{ paddingTop: "5px" }}
                  >
                    <Stack
                      direction="column"
                      alignItems={"center"}
                      spacing={0.5}
                    >
                      <Typography className="thead-text-dusburment">
                        អ្នកធ្វើតារាង
                      </Typography>
                      <Typography className="thead-text-dusburment">
                        Prepared by
                      </Typography>
                    </Stack>
                    <Stack
                      alignItems={"center"}
                      direction="column"
                      className="text-field-disbursement"
                    >
                      <Typography
                        className="text-field-disbursement"
                        onClick={() => setShowPrepareBy(true)}
                        sx={{
                          marginTop: "45px",
                          borderBottom: "1px solid #c1cbf5",
                          cursor: "pointer",
                        }}
                      >
                        {prepareByValue ? prepareByValue : "ឈ្មោះអ្នកធ្វើតារាង"}
                      </Typography>

                      {showPrepareBy ? (
                        <Typography className="title-student-parents-info">
                          <TextField
                            className="text-field-disbursement"
                            size="small"
                            onMouseLeave={() => setShowPrepareBy(false)}
                            value={prepareByValue}
                            onChange={(e) => handlePrepareBy(e?.target?.value)}
                          />
                        </Typography>
                      ) : null}
                    </Stack>
                    <Stack direction="column" width="100%">
                      <Stack direction="row" spacing={0} width="100%">
                        <Typography className="thead-text-dusburment" sx={{ whiteSpace: 'nowrap' }}>
                          Date:
                        </Typography>
                        <Box
                          sx={{
                            borderBottom: '1px dashed gray',
                            flexGrow: 1, 
                            mb: "4px",
                          }}
                        /> 
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" justifyContent="right" width="100%">
          <ReactToPrint
            content={reactToPrintContent}
            documentTitle={`Invoice-${printData?.numbering}`}
            removeAfterPrint
            trigger={reactToPrintTrigger}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
